
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-20"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Modern%20professional%20Japanese%20business%20consulting%20office%20environment%20with%20bright%20natural%20lighting%20from%20large%20windows%20showing%20clean%20minimalist%20workspace%20with%20elegant%20wooden%20desk%20contemporary%20furniture%20and%20subtle%20blue%20accent%20colors%20in%20background%20soft%20focus%20creating%20depth%20professional%20atmosphere%20with%20organized%20documents%20and%20laptop%20on%20desk%20representing%20trust%20expertise%20and%20corporate%20success%20in%20subsidy%20consulting%20services%20ultra%20sharp%20high%20quality%20corporate%20photography%20with%20left%20side%20having%20solid%20light%20blue-white%20gradient%20background%20perfect%20for%20text%20overlay%20ensuring%20maximum%20readability&width=1920&height=1080&seq=hero001&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <div className="inline-block bg-blue-900/10 backdrop-blur-sm px-6 py-3 rounded-full mb-8">
            <span className="text-blue-900 font-bold text-lg">東京・神奈川の中小企業専用</span>
          </div>

          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            補助金 × 法務 × LP制作<br />
            <span className="text-blue-900">3つを一社で完結</span>
          </h2>

          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            バラバラに依頼していた補助金申請・法務相談・集客支援を、<br />
            <strong className="text-blue-900">一気通貫でサポート</strong>する新しい形のコンサルティング
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={scrollToContact}
              className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              無料補助金診断を依頼する
            </button>
            <a 
              href="tel:08073973298"
              className="bg-white text-blue-900 border-2 border-blue-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-50 transition-all cursor-pointer whitespace-nowrap text-center"
            >
              <i className="ri-phone-line mr-2"></i>
              080-7397-3298
            </a>
          </div>

          <div className="grid grid-cols-3 gap-6">
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 shadow-lg">
              <div className="text-4xl font-bold text-blue-900 mb-2">1000件+</div>
              <div className="text-sm text-gray-700 font-medium">対応可能制度</div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 shadow-lg">
              <div className="text-4xl font-bold text-blue-900 mb-2">成功報酬</div>
              <div className="text-sm text-gray-700 font-medium">採択後のみ</div>
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-6 shadow-lg">
              <div className="text-4xl font-bold text-blue-900 mb-2">ワンストップ</div>
              <div className="text-sm text-gray-700 font-medium">全て一社で対応</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
